module.exports = __webpack_public_path__ + "static/media/smspilot-logo.8f9d230f.svg";